import { render, staticRenderFns } from "./kowledgePointsVideo.vue?vue&type=template&id=ef098932&scoped=true"
import script from "./kowledgePointsVideo.vue?vue&type=script&lang=js"
export * from "./kowledgePointsVideo.vue?vue&type=script&lang=js"
import style0 from "./kowledgePointsVideo.vue?vue&type=style&index=0&id=ef098932&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef098932",
  null
  
)

export default component.exports